var cov_2iy4mlep4d = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/strings.ts",
      hash = "df85cfca74c96a24c9b8293c247322edcb00b9fd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/strings.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "1": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 54
        }
      },
      "2": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 51
        }
      },
      "3": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "4": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      "5": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 16
        }
      },
      "6": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 21,
          column: 6
        }
      },
      "7": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 19,
          column: 7
        }
      },
      "8": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "9": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 75
        }
      },
      "10": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "11": {
        start: {
          line: 24,
          column: 14
        },
        end: {
          line: 24,
          column: 22
        }
      },
      "12": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 27,
          column: 5
        }
      },
      "13": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 34
        }
      },
      "14": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 14
        }
      },
      "15": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 11
        }
      },
      "16": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 43
        }
      },
      "17": {
        start: {
          line: 35,
          column: 33
        },
        end: {
          line: 35,
          column: 43
        }
      },
      "18": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "19": {
        start: {
          line: 37,
          column: 31
        },
        end: {
          line: 37,
          column: 43
        }
      },
      "20": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "21": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 14
        }
      },
      "22": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "23": {
        start: {
          line: 45,
          column: 17
        },
        end: {
          line: 45,
          column: 32
        }
      },
      "24": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "25": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 44
        }
      },
      "26": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 52,
          column: 3
        }
      },
      "27": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 44
        }
      },
      "28": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 53,
          column: 17
        }
      },
      "29": {
        start: {
          line: 57,
          column: 14
        },
        end: {
          line: 57,
          column: 21
        }
      },
      "30": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "31": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "32": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 55
        }
      },
      "33": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 51
        }
      },
      "34": {
        start: {
          line: 65,
          column: 2
        },
        end: {
          line: 67,
          column: 3
        }
      },
      "35": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 51
        }
      },
      "36": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 51
        }
      }
    },
    fnMap: {
      "0": {
        name: "capitalize",
        decl: {
          start: {
            line: 3,
            column: 16
          },
          end: {
            line: 3,
            column: 26
          }
        },
        loc: {
          start: {
            line: 3,
            column: 40
          },
          end: {
            line: 8,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "substitute",
        decl: {
          start: {
            line: 10,
            column: 16
          },
          end: {
            line: 10,
            column: 26
          }
        },
        loc: {
          start: {
            line: 10,
            column: 78
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 43
          },
          end: {
            line: 16,
            column: 44
          }
        },
        loc: {
          start: {
            line: 16,
            column: 60
          },
          end: {
            line: 21,
            column: 5
          }
        },
        line: 16
      },
      "3": {
        name: "removeProtocol",
        decl: {
          start: {
            line: 34,
            column: 16
          },
          end: {
            line: 34,
            column: 30
          }
        },
        loc: {
          start: {
            line: 34,
            column: 44
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 34
      },
      "4": {
        name: "getRTLPosition",
        decl: {
          start: {
            line: 44,
            column: 16
          },
          end: {
            line: 44,
            column: 30
          }
        },
        loc: {
          start: {
            line: 44,
            column: 49
          },
          end: {
            line: 54,
            column: 1
          }
        },
        line: 44
      },
      "5": {
        name: "getDirectionIconName",
        decl: {
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 56,
            column: 36
          }
        },
        loc: {
          start: {
            line: 56,
            column: 68
          },
          end: {
            line: 69,
            column: 1
          }
        },
        line: 56
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 12
          }
        }, {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 51
          }
        }],
        line: 7
      },
      "2": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 11
      },
      "3": {
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 14,
            column: 5
          }
        }],
        line: 12
      },
      "4": {
        loc: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }, {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }],
        line: 17
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 20,
            column: 61
          },
          end: {
            line: 20,
            column: 63
          }
        }, {
          start: {
            line: 20,
            column: 66
          },
          end: {
            line: 20,
            column: 75
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 31
          }
        }, {
          start: {
            line: 20,
            column: 35
          },
          end: {
            line: 20,
            column: 58
          }
        }],
        line: 20
      },
      "7": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }],
        line: 23
      },
      "8": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 27,
            column: 5
          }
        }],
        line: 25
      },
      "9": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 19
          }
        }, {
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 46
          }
        }],
        line: 25
      },
      "10": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        }],
        line: 35
      },
      "11": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 32
          }
        }],
        line: 45
      },
      "12": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        }],
        line: 47
      },
      "13": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }, {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        }],
        line: 50
      },
      "14": {
        loc: {
          start: {
            line: 56,
            column: 37
          },
          end: {
            line: 56,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 44
          },
          end: {
            line: 56,
            column: 50
          }
        }],
        line: 56
      },
      "15": {
        loc: {
          start: {
            line: 56,
            column: 52
          },
          end: {
            line: 56,
            column: 66
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 56,
            column: 61
          },
          end: {
            line: 56,
            column: 66
          }
        }],
        line: 56
      },
      "16": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        }],
        line: 58
      },
      "17": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 61,
            column: 5
          }
        }],
        line: 59
      },
      "18": {
        loc: {
          start: {
            line: 60,
            column: 13
          },
          end: {
            line: 60,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 22
          },
          end: {
            line: 60,
            column: 40
          }
        }, {
          start: {
            line: 60,
            column: 43
          },
          end: {
            line: 60,
            column: 55
          }
        }],
        line: 60
      },
      "19": {
        loc: {
          start: {
            line: 62,
            column: 11
          },
          end: {
            line: 62,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 20
          },
          end: {
            line: 62,
            column: 37
          }
        }, {
          start: {
            line: 62,
            column: 40
          },
          end: {
            line: 62,
            column: 51
          }
        }],
        line: 62
      },
      "20": {
        loc: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        }, {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        }],
        line: 65
      },
      "21": {
        loc: {
          start: {
            line: 66,
            column: 11
          },
          end: {
            line: 66,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 20
          },
          end: {
            line: 66,
            column: 37
          }
        }, {
          start: {
            line: 66,
            column: 40
          },
          end: {
            line: 66,
            column: 51
          }
        }],
        line: 66
      },
      "22": {
        loc: {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 18
          },
          end: {
            line: 68,
            column: 36
          }
        }, {
          start: {
            line: 68,
            column: 39
          },
          end: {
            line: 68,
            column: 51
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0],
      "15": [0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { isRTL } from '../config';
export function capitalize(str) {
  cov_2iy4mlep4d.f[0]++;
  cov_2iy4mlep4d.s[0]++;

  if (typeof str !== 'string') {
    cov_2iy4mlep4d.b[0][0]++;
    cov_2iy4mlep4d.s[1]++;
    console.error(new Error('str should be a string'));
  } else {
    cov_2iy4mlep4d.b[0][1]++;
  }

  cov_2iy4mlep4d.s[2]++;
  return (cov_2iy4mlep4d.b[1][0]++, str) && (cov_2iy4mlep4d.b[1][1]++, str[0].toUpperCase() + str.slice(1));
}
export function substitute(str, obj) {
  cov_2iy4mlep4d.f[1]++;
  cov_2iy4mlep4d.s[3]++;

  if (typeof str === 'string') {
    cov_2iy4mlep4d.b[2][0]++;
    cov_2iy4mlep4d.s[4]++;

    if (str.indexOf('{') < 0) {
      cov_2iy4mlep4d.b[3][0]++;
      cov_2iy4mlep4d.s[5]++;
      return str;
    } else {
      cov_2iy4mlep4d.b[3][1]++;
    }

    cov_2iy4mlep4d.s[6]++;
    return str.replace(/\\?\{([^{}]+)\}/g, function (match, name) {
      cov_2iy4mlep4d.f[2]++;
      cov_2iy4mlep4d.s[7]++;

      if (match.charAt(0) === '\\') {
        cov_2iy4mlep4d.b[4][0]++;
        cov_2iy4mlep4d.s[8]++;
        return match.slice(1);
      } else {
        cov_2iy4mlep4d.b[4][1]++;
      }

      cov_2iy4mlep4d.s[9]++;
      return (cov_2iy4mlep4d.b[6][0]++, obj[name] === null) || (cov_2iy4mlep4d.b[6][1]++, obj[name] === undefined) ? (cov_2iy4mlep4d.b[5][0]++, '') : (cov_2iy4mlep4d.b[5][1]++, obj[name]);
    });
  } else {
    cov_2iy4mlep4d.b[2][1]++;
  }

  cov_2iy4mlep4d.s[10]++;

  if (typeof str === 'function') {
    cov_2iy4mlep4d.b[7][0]++;
    var val = (cov_2iy4mlep4d.s[11]++, str(obj));
    cov_2iy4mlep4d.s[12]++;

    if ((cov_2iy4mlep4d.b[9][0]++, val === obj) && (cov_2iy4mlep4d.b[9][1]++, typeof val === 'object')) {
      cov_2iy4mlep4d.b[8][0]++;
      cov_2iy4mlep4d.s[13]++;
      val = Object.assign({}, obj);
    } else {
      cov_2iy4mlep4d.b[8][1]++;
    }

    cov_2iy4mlep4d.s[14]++;
    return val;
  } else {
    cov_2iy4mlep4d.b[7][1]++;
  }

  cov_2iy4mlep4d.s[15]++;
  return '';
}
export function removeProtocol(url) {
  cov_2iy4mlep4d.f[3]++;
  cov_2iy4mlep4d.s[16]++;

  if (url.indexOf('http') !== 0) {
    cov_2iy4mlep4d.b[10][0]++;
    cov_2iy4mlep4d.s[17]++;
    return url;
  } else {
    cov_2iy4mlep4d.b[10][1]++;
  }

  cov_2iy4mlep4d.s[18]++;

  try {
    var _ref = (cov_2iy4mlep4d.s[19]++, new URL(url)),
        href = _ref.href,
        protocol = _ref.protocol;

    cov_2iy4mlep4d.s[20]++;
    return href.slice(protocol.length);
  } catch (error) {
    cov_2iy4mlep4d.s[21]++;
    return url;
  }
}
export function getRTLPosition(position) {
  cov_2iy4mlep4d.f[4]++;
  cov_2iy4mlep4d.s[22]++;

  if (!position) {
    cov_2iy4mlep4d.b[11][0]++;
    cov_2iy4mlep4d.s[23]++;
    return position;
  } else {
    cov_2iy4mlep4d.b[11][1]++;
  } // position.replace('left', 'right').replace('right', 'left')


  cov_2iy4mlep4d.s[24]++;

  if (position.indexOf('left') !== -1) {
    cov_2iy4mlep4d.b[12][0]++;
    cov_2iy4mlep4d.s[25]++;
    return position.replace('left', 'right');
  } else {
    cov_2iy4mlep4d.b[12][1]++;
  }

  cov_2iy4mlep4d.s[26]++;

  if (position.indexOf('right') !== -1) {
    cov_2iy4mlep4d.b[13][0]++;
    cov_2iy4mlep4d.s[27]++;
    return position.replace('right', 'left');
  } else {
    cov_2iy4mlep4d.b[13][1]++;
  }

  cov_2iy4mlep4d.s[28]++;
  return position;
}
export function getDirectionIconName() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_2iy4mlep4d.b[14][0]++, 'left');

  var _double = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2iy4mlep4d.b[15][0]++, false);

  cov_2iy4mlep4d.f[5]++;
  var rtl = (cov_2iy4mlep4d.s[29]++, isRTL());
  cov_2iy4mlep4d.s[30]++;

  if (mode === 'left') {
    cov_2iy4mlep4d.b[16][0]++;
    cov_2iy4mlep4d.s[31]++;

    if (rtl) {
      cov_2iy4mlep4d.b[17][0]++;
      cov_2iy4mlep4d.s[32]++;
      return _double ? (cov_2iy4mlep4d.b[18][0]++, 'AngleDoubleRight') : (cov_2iy4mlep4d.b[18][1]++, 'AngleRight');
    } else {
      cov_2iy4mlep4d.b[17][1]++;
    }

    cov_2iy4mlep4d.s[33]++;
    return _double ? (cov_2iy4mlep4d.b[19][0]++, 'AngleDoubleLeft') : (cov_2iy4mlep4d.b[19][1]++, 'AngleLeft');
  } else {
    cov_2iy4mlep4d.b[16][1]++;
  }

  cov_2iy4mlep4d.s[34]++;

  if (rtl) {
    cov_2iy4mlep4d.b[20][0]++;
    cov_2iy4mlep4d.s[35]++;
    return _double ? (cov_2iy4mlep4d.b[21][0]++, 'AngleDoubleLeft') : (cov_2iy4mlep4d.b[21][1]++, 'AngleLeft');
  } else {
    cov_2iy4mlep4d.b[20][1]++;
  }

  cov_2iy4mlep4d.s[36]++;
  return _double ? (cov_2iy4mlep4d.b[22][0]++, 'AngleDoubleRight') : (cov_2iy4mlep4d.b[22][1]++, 'AngleRight');
}